/**
 * svg-icon 添加方法
 * 直接复制.svg文件到svg文件夹下
 * 使用方法
 * <svg-icon icon-class="link" title="提示" :fill="true" className="add"/>
 */
import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg组件

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)

/**
 * icon对应文件名称
 名称 icon
 **/
